// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_b9-3";
export var contentContainer = "_b9-0";
export var editorContainer = "_b9-1";
export var quillInputForm = "_b9-2";
export var zoneDivider = "_b9-4";